import { useEffect, useState} from 'react';

import axios from 'axios';

const useFetchData = ({catid, setLoading}) => {
  const [data, setData] = useState({});
  

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const { data: response } = await axios.get(`https://bulkify.in/api/vendor/fetch_catogory.php?catid=${catid}`);
        setData(response);
      } catch (error) {
        console.error(error)
      }
      finally{
        setLoading(false);
      }
      
    };

    fetchData();
  }, [catid, setLoading]);

  return {data};
};

export default useFetchData;